module.exports = __webpack_public_path__ + "static/media/img_Invoice@3x.ff509579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Invoice@3x.png
// module id = 947
// module chunks = 0